module.exports = __webpack_public_path__ + "img/pf.6d658022.svg";